import { RootState } from 'redux/store'

export const notificationSelector = (state: RootState) =>
  state.notificationReducer
